import BaseService from './baseService';

class Jadwal extends BaseService {
	async getJadwal(month) {
    this.endPoint = '/schedule?month='+month;
		return this.get();
  }
	async getProductJasa(opts = {}) {
    this.endPoint = '/products-by-id-category/6';
		return this.get(opts);
  }
	async getProductJasaEdit(payload, opts = {}) {
    this.endPoint = '/products-by-id-category-harga';
    return await this.post(payload);
  }
  async createJadwal(payload){
    this.endPoint = '/schedule';
    return await this.post(payload); 
  }
  async cekJadwal(payload){
    this.endPoint = '/schedule/cek';
    return await this.post(payload); 
  }
  async updateJadwal(id,payload,opts={}){
    this.endPoint = '/schedule';
    return await this.putOne(id,payload,opts);
  }
  async deleteJadwal(id,opts={}){
    this.endPoint = '/submission';
    return await this.delete(id,opts);
  }
}

export default new Jadwal();